import { useState } from "react";
import { callAPI } from "../hooks/CallAPI";
import { toast } from "react-toastify";
import LoadingWrapper from '../components/LoadingWrapper'; 
import Input from "../components/FormElements/Input";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Footer from "../components/Footer.jsx";
import { useNavigate } from "react-router-dom";
import BackButton from '../components/Buttons/BackButton';


const ResetPasswordRequest = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [user_login, setUserLogin] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await callAPI('/request-password-reset', { user_login });
            console.log("Réponse API:", response);

            if (response.success) {
                toast.success("Un lien de réinitialisation a été envoyé par e-mail.");
                navigate('/')
            }

        } catch (error) {
            toast.error("Erreur lors de la demande de réinitialisation.");
        }
    };

    return (
        <div className="flex flex-col justify-between h-screen">
            <BackButton className="text-black" />
            <div className="header bg-mgray text-mdark py-8 px-10 text-center">
                <p className="text-lg font-bold text-custom-color">Bienvenue dans votre espace client</p>
                <h1 className="text-xl sm:text-4xl font-extrabold text-mlime mb-4 uppercase">Demande de réinitialisation de votre mot de passe</h1>
            </div>
            <div className="container mx-auto px-10 py-10">

                <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                    <p className="pb-8 text-center">Veuillez saisir votre adresse e-mail ci-dessous.<br></br> Un lien de réinitialisation de mot de passe vous sera envoyé par e-mail si cette adresse est associée à un compte existant.</p>
                    <Input 
                        name="user_login"
                        label="Confirmer votre adresse mail"
                        value={user_login}
                        onChange={(e) => setUserLogin(e.target.value)}
                    />

                    <div className="relative">
                        <button type="submit" className="bg-mlime px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold text-center m-auto  duration-500 hover:bg-colorbutton">
                            <LoadingWrapper isLoading={isLoading}>
                                Envoyer la demande <FontAwesomeIcon className="ml-3" icon="fa-regular fa-paper-plane" />
                            </LoadingWrapper>
                        </button>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default ResetPasswordRequest;
